<!--
 * @Descripttion:
 * @version:
 * @Author: sueRimn
 * @Date: 2020-12-07 13:36:38
 * @LastEditors: sueRimn
 * @LastEditTime: 2020-12-09 14:20:39
-->
<template>
  <div class="EnterAmount">
    <div class="EnterAmount_text">
      输入金额(元）
    </div>
    <AmountPageIn textButton="确认转入" :getAmountNum="getAmountNum" />
    <self-popup v-model="ShowPopupContent"></self-popup>
  </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex';
import AmountPageIn from './components/AmountPageIn.vue';

export default {
  name: 'EnterAmount',
  data() {
    return {
      // 弹窗
      ShowPopupContent: '',
    };
  },
  components: {
    AmountPageIn,
  },
  computed: {
    ...mapState({
      capitalAccount(val) {
        return val.capitalAccount;
      },
    }),
  },
  methods: {
    ...mapMutations('capitalAccount', ['updateState']),
    getAmountNum(val, cb) {
      this.$api.CommonForms.bandlerRecharge({
        orderId: this.capitalAccount.orderId,
        amount: val.amountValue,
        bindingCardId: val.selectValueID,
      })
        .then((res) => {
          if (res.success) {
            this.$router.push(
              `/supermarket/v2/ToIntoingIn?trans_no=${res.data.trans_no}&isInto=${true}&orderId=${
                this.capitalAccount.orderId
              }&amount=${val.amountValue}`,
            );
          } else {
            this.ShowPopupContent = res.returnMessage;
          }
          // eslint-disable-next-line no-unused-expressions
          cb && cb();
        })
        .catch(() => {
          this.ShowPopupContent = '网络异常，请稍后再试！';
        });
    },
  },
};
</script>
<style scoped>
.EnterAmount_text {
  height: 44px;
  background: #ffffff;
  line-height: 44px;
  text-align: left;
  padding-left: 16px;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #1c2438;
}
</style>
